import { render, staticRenderFns } from "./OpenMailClient.vue?vue&type=template&id=fdd83806&"
import script from "./OpenMailClient.vue?vue&type=script&lang=js&"
export * from "./OpenMailClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports